const EMPTY_PATH = '/';

function getCanonicalFromCustomDomain(fastboot) {
  if (fastboot?.isFastBoot) {
    let request = fastboot?.request;
    let customDomain = request?.headers?.headers?.['custom-domain']?.[0];
    if (customDomain) {
      return { host: customDomain, path: request?.path || EMPTY_PATH };
    }
  }
}

function getCanonicalFromRequest(fastboot) {
  if (fastboot?.isFastBoot) {
    let request = fastboot?.request;
    return { host: request?.host, path: request?.path || EMPTY_PATH };
  }
}

function getCanonicalFromTransition(transition, router, window) {
  if (!transition || !router || !transition.to || !window) return null;

  const routeName = transition.to.name;
  const params = transition.to.params;

  let path = router.urlFor(routeName, ...Object.values(params));
  const host = window?.location?.host;

  if (host && path) {
    return { host, path };
  }
}

function getCanonicalFromWindow(window) {
  return { host: window.location.host, path: window.location.pathname };
}

function getProtocol(fastboot, window) {
  if (fastboot?.isFastBoot) {
    return (fastboot.request?.protocol || 'https') + ':';
  }
  return window.location.protocol;
}

function stripQueryAndHash(path) {
  return path.split('?')[0].split('#')[0];
}

export default function getCanonicalUrl({ transition, fastboot, router, window }) {
  try {
    const protocol = getProtocol(fastboot, window);

    let result =
      getCanonicalFromCustomDomain(fastboot) ||
      getCanonicalFromRequest(fastboot) ||
      getCanonicalFromTransition(transition, router, window) ||
      getCanonicalFromWindow(window);

    return stripQueryAndHash(`${protocol}//${result.host}${result.path}`);
  } catch (e) {
    window?._bugsnagClient?.notify(e);
  }
}
